export default class InvalidJsonPointerError extends Error {
  constructor(pointer) {
    super(`Invalid JSON Pointer "${pointer}". Pointers must begin with "/"`);
    this.name = this.constructor.name;
    this.message = `Invalid JSON Pointer "${pointer}". Pointers must begin with "/"`;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(`Invalid JSON Pointer "${pointer}". Pointers must begin with "/"`).stack;
    }
  }
}